import React from 'react'
import Message from './Message'

/* doc
---
title: PrimaryMessage
name: PrimaryMessage
category: React - Bulma
parent: Message
---

A `PrimaryMessage` component applies the `.is-primary` class to the `Message` component.

Use this component to display a message styled with the site's primary color.

See the `Message` documentation for further information.

```html_example
  <PrimaryMessage>
    <MessageHeader>...</MessageHeader>
    <MessageBody>
      ...
    </MessageBody>
  </PrimaryMessage>
```
*/
function PrimaryMessage(props) {
  const { className, children, ...rest } = props

  const classes = [
    'is-primary',
    className || '',
  ]

  return (
    <Message {...rest} className={classes.join(' ')}>
      {children}
    </Message>
  )
}

export default PrimaryMessage
